<div class="container" *ngIf="this.currentInvoice">
    <div class="left"><app-pdf-viewer [fileUrl]="this.currentInvoice.downloadUrl"></app-pdf-viewer></div>
  <div class="right">
      <app-invoice-controls  [currentIndex]="this.currentIndex" [maxIndex]="this.maxIndex" (numberChange)="onIndexChange($event)"></app-invoice-controls> 
    <app-datacollectionsent-form [currentInvoice]="this.currentInvoice" [currentIndex]="this.currentIndex" [clientId]="this.clientId"></app-datacollectionsent-form>
  </div>
</div>
